var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('Navbar'),_c('div',{staticClass:"offset"},[_c('div',{staticClass:"col-md-6"},[_c('Home',{staticClass:"fixed-home"})],1),_c('div',{staticClass:"col-md-6"},[_c('Work'),_c('Projects',{staticClass:"my-5"})],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }